import { ChargeAccountJourneysController } from './journeys/charge-account-journeys.controller';
import { ChargeAccountSummaryController } from './summary/charge-account-summary.controller';
import { ChargeAccountPaymentsController } from './payments/charge-account-payments.controller';
import { ChargeAccountProductsController } from './products/charge-account-products.controller';
import { ChargeAccountStatementController } from './statement/charge-account-statement.controller';
import { ChargeAccountPaymentDetailsController } from './payments/payment-details/charge-account-payment-details.controller';

import * as ChargeAccountRoutes from './charge-account.routes';

/**
 * The entry point the charge accounts module
 */
export const initialise = () => {
  angular.module('app.charge-account', [
    'pascalprecht.translate',
    'actora.services',
    'actora.customers',
    'app.layout',
    'app.components'
  ]).controller('chargeAccountSummaryController', <ng.IControllerConstructor>ChargeAccountSummaryController)
    .controller('chargeAccountPaymentsController', <ng.IControllerConstructor>ChargeAccountPaymentsController)
    .controller('chargeAccountJourneysController', <ng.IControllerConstructor>ChargeAccountJourneysController)
    .controller('chargeAccountProductsController', <ng.IControllerConstructor>ChargeAccountProductsController)
    .controller('chargeAccountPaymentDetailsController', <ng.IControllerConstructor>ChargeAccountPaymentDetailsController)
    .controller('chargeAccountStatementController', <ng.IControllerConstructor>ChargeAccountStatementController);
  ChargeAccountRoutes.initialise();
};